window.VAE = window.VAE || {};

VAE.ContentHasher = (function() {
  'use strict';
  
  // Elements that are likely to contain dynamic content
  const DYNAMIC_SELECTORS = [
    // User-specific content
    '[data-user]', '.user-specific', '.account-info',
    // Timestamps, dates
    '[data-timestamp]', '.timestamp', '.date', 'time',
    // Counters, metrics
    '.counter', '.metrics', '.views', '.likes',
    // Dynamic lists/feeds
    '.feed', '.stream', '.timeline',
    // Ads and recommendations
    '[data-ad]', '.ad', '.advertisement', '.recommended',
    // Comments
    '.comments', '.comment-section',
    // CSRF tokens, form specifics
    'input[name*="csrf"]', 'input[name*="token"]',
    // Shopping cart related
    '.cart', '.basket', '.shopping-bag',
    // Notifications
    '.notification', '.alert', '.toast',
    // Analytics and tracking
    '[data-analytics]', '[data-tracking]'
  ];
  
  // Attributes that may contain dynamic values
  const DYNAMIC_ATTRIBUTES = [
    'data-timestamp', 'data-count', 'data-views', 
    'data-user-id', 'data-session', 'data-analytics'
  ];

  function cleanHtml(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    doc.querySelectorAll('script').forEach(el => el.remove());
    
    doc.querySelectorAll('*').forEach(el => {
      const attributes = Array.from(el.attributes);
      attributes.forEach(attr => {
        if (attr.name.startsWith('on')) {
          el.removeAttribute(attr.name);
        }
      });
    });
    
    DYNAMIC_SELECTORS.forEach(selector => {
      try {
        doc.querySelectorAll(selector).forEach(el => {
          el.innerHTML = '';
        });
      } catch (err) {
        console.warn(`VAE.ContentHasher: Invalid selector "${selector}":`, err);
      }
    });
    
    doc.querySelectorAll('*').forEach(el => {
      DYNAMIC_ATTRIBUTES.forEach(attr => {
        if (el.hasAttribute(attr)) {
          el.removeAttribute(attr);
        }
      });
    });
    
    doc.querySelectorAll('[id^="vae-"]').forEach(el => el.remove());
    
    removeHtmlComments(doc);
    
    return doc.documentElement.outerHTML;
  }
  
  function removeHtmlComments(doc) {
    const nodeIterator = doc.createNodeIterator(
      doc.documentElement,
      NodeFilter.SHOW_COMMENT,
      null
    );
    
    let node;
    const commentsToRemove = [];
    
    while (node = nodeIterator.nextNode()) {
      commentsToRemove.push(node);
    }
    
    commentsToRemove.forEach(comment => comment.parentNode.removeChild(comment));
  }
  
  function generateHash(html) {
    const cleanedHtml = cleanHtml(html);
    
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(cleanedHtml))
      .then(hashBuffer => {
        return Array.from(new Uint8Array(hashBuffer))
          .map(b => b.toString(16).padStart(2, '0'))
          .join('');
      })
      .catch(err => {
        console.error('VAE.ContentHasher: Hashing error:', err);
        return Promise.resolve(simpleHash(cleanedHtml));
      });
  }
  
  function simpleHash(str) {
    let hash = 5381;
    
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) + hash) + str.charCodeAt(i);
    }
    
    return (hash >>> 0).toString(16);
  }
  
  function getCurrentPageHash() {
    const html = document.documentElement.outerHTML;
    return generateHash(html);
  }
  
  return {
    cleanHtml,
    generateHash,
    getCurrentPageHash
  };
})();

console.log('VAE: ContentHasher-Modul initialisiert');

export default VAE.ContentHasher; 